import { render, staticRenderFns } from "./OldMemberPopup.vue?vue&type=template&id=4b08677c&scoped=true"
import script from "./OldMemberPopup.vue?vue&type=script&lang=js"
export * from "./OldMemberPopup.vue?vue&type=script&lang=js"
import style0 from "./OldMemberPopup.vue?vue&type=style&index=0&id=4b08677c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08677c",
  null
  
)

export default component.exports